module.exports = __webpack_public_path__ + "img/DSC_1593.e8743450.jpg";